import React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/app/App";
import "./assets/cleanup.css";
import "./libs/string.extension";

import { Provider } from "react-redux";
import configureRedux from "./redux/configureRedux";
import environment from "./environment";
import { initAnalytics } from "./libs/amplitudeHelper";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";

const initialState = {};
const store = configureRedux(initialState);
initAnalytics(environment.versionDescription);

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: environment.launchDarkly.sdkKey
      ? environment.launchDarkly.sdkKey
      : "",
    options: {},
  });
  const container = document.getElementById("root");
  if (!container) throw new Error("Root element #root not found");
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <LDProvider>
          <App />
        </LDProvider>
      </Provider>
    </React.StrictMode>
  );
})();
